import React from 'react';
import { theme } from '../../../theme';

interface SellerLevelIcon {
    color?: 'currentColor' | 'empty';
}

export const SellerLevelDiamondIcon = ({ color = 'currentColor' }: SellerLevelIcon) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 8 8"
        width={8}
        height={8}
        fill={color === 'empty' ? theme.colors.grey1100 : 'currentColor'}
    >
        <path d="M3.59748 0.546223C3.79732 0.275045 4.20268 0.275044 4.40252 0.546222L5.65213 2.24197C5.68191 2.28239 5.71761 2.31809 5.75803 2.34787L7.45378 3.59748C7.72495 3.79732 7.72496 4.20268 7.45378 4.40252L5.75803 5.65213C5.71761 5.68191 5.68191 5.71761 5.65213 5.75803L4.40252 7.45378C4.20268 7.72495 3.79732 7.72496 3.59748 7.45378L2.34787 5.75803C2.31809 5.71761 2.28239 5.68191 2.24197 5.65213L0.546223 4.40252C0.275045 4.20268 0.275044 3.79732 0.546222 3.59748L2.24197 2.34787C2.28239 2.31809 2.31809 2.28239 2.34787 2.24197L3.59748 0.546223Z" />
    </svg>
);

SellerLevelDiamondIcon.displayName = 'SellerLevelDiamondIcon';
